import Backdrop from "@/components/base/backdrop";
import PageLayout from "@/components/base/page-layout";
import Brands from "@/components/brands";
import withErrorBoundary from "@/components/hoc/with-error-boundary";
import useQueryBrands from "@/hooks/queries/useQueryBrands";
import React from "react";

const BrandsPage: React.FC = () => {
  const { data: brands, isFetching } = useQueryBrands();

  if (!brands) {
    return <Backdrop loading={isFetching} />;
  }

  return (
    <PageLayout title="Brands">
      <Brands data={brands} />
    </PageLayout>
  );
};

export default withErrorBoundary({ component: "BrandsPage" })(BrandsPage);
